import { FONT_SIZE } from "../../../theme/tokens";
import type { CustomPrintoutEffort } from "./customPrintoutTypes";

/** About five rows before the printout list scrolls, so the design chat under it keeps its room. */
export const LIST_MAX_HEIGHT_PX = 184;

/** The viewed day in a printout's print title: sorts by date as a file name, and reads the same in every language. */
export const PRINT_TITLE_DATE_FORMAT = "yyyy-MM-dd";

/** How tall the design composer grows before it scrolls: a long request, not a pasted document. */
export const COMPOSER_MAX_ROWS = 6;

/** Under the `lg` breakpoint the chat has less height to spare, so the composer stops sooner. */
export const COMPOSER_MAX_ROWS_MEDIUM = 4;

/** Under the `md` breakpoint the panels stack and the composer shares the screen with the preview, so it stops sooner still. */
export const COMPOSER_MAX_ROWS_NARROW = 3;

/** The preview's loading dots: big enough to read as "loading" in the middle of a page-sized pane. */
export const PREVIEW_LOADER_DOT_PX = 8;

/** On a phone-width popup the panes stack: the design pane takes this share of the height, the preview the rest. */
export const STACKED_DESIGN_PANE_SHARE = "55%";

/**
 * The thinking level the composer starts each popup session at.
 * DEFAULT: high — what every design ran at before the level could be chosen; a lower one is the designer's call.
 */
export const INITIAL_CUSTOM_PRINTOUT_EFFORT: CustomPrintoutEffort = "high";

/** A new printout's row key in the list: it has no id until it is saved. */
export const NEW_PRINTOUT_ROW_KEY = "new";

/** The chat sits in the ~280px left pane, so its bubbles take the panel's denser type and padding. */
export const BUBBLE_SX = { fontSize: FONT_SIZE.SECONDARY, px: 1.25, py: 0.75 } as const;
export const BUBBLE_MAX_WIDTH = "92%";
